import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Container, Header } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import FormularioCompleto from '../../comun/FormularioCompleto';
import ModalError from '../../comun/ModalError';
import { MatriculaState } from '../../comun/tipos';
import { PanelDeSupervision } from './PanelDeSupervision';

type Props = RouteComponentProps<{ id: string }>;

export interface Verificacion {
    tieneHuellas: boolean;
    tieneFotocopias: boolean;
    tieneFirmas: boolean;
}

export interface EstadoVerificacion extends Verificacion {
    estado: 'pendiente' | 'verificada';
}

interface State {
    botonRechazar: boolean;
    aprobacion: {
        estado: 'aprobado' | 'rechazado' | 'sin-supervision';
        motivo: string;
    };
    verificacion: EstadoVerificacion;
    error?: {
        mensaje: string;
        detalles: Array<string>;
    };
    matriculaState?: MatriculaState;
    pdf?: string;
}

const stateInicial: State = {
    botonRechazar: false,
    aprobacion: {
        estado: 'sin-supervision',
        motivo: '',
    },
    verificacion: {
        tieneHuellas: false,
        tieneFotocopias: false,
        tieneFirmas: false,
        estado: 'pendiente',
    },
};

class ProcesoDeMatricula extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = stateInicial;
    private readonly idProceso = parseInt(this.props.match.params.id, 10);

    public componentDidMount() {
        this.obtenerMatricula().catch(this.context.mostrarModalError);
    }

    public render() {
        const { matriculaState, pdf, error } = this.state;

        if (error) {
            return (
                <ModalError
                    mensaje={error.mensaje}
                    detalles={error.detalles}
                    alCerrar={() => this.setState({ error: undefined })}
                />
            );
        }

        if (!matriculaState || !pdf) {
            return <Header as='h1'>Cargando...</Header>;
        }

        return (
            <Container>
                <PanelDeSupervision
                    idProceso={matriculaState.id}
                    aprobarMatricula={this.aprobarMatricula}
                    rechazarMatricula={this.rechazarMatricula}
                    aprobacion={this.state.aprobacion}
                    verificacion={this.state.verificacion}
                    actualizarEstadoVerificacion={this.actualizarVerificacion}
                    pdf={pdf}
                />

                <FormularioCompleto {...matriculaState} />
            </Container>
        );
    }

    private readonly obtenerMatricula = async () => {
        const proceso = await clienteApi.ejecutar('procesoDeMatriculaDeId', this.idProceso);
        const { pdf } = await clienteApi.ejecutar('documentosDelProcesoDeId', this.idProceso);

        this.setState({
            matriculaState: proceso.state,
            pdf,
            aprobacion: { motivo: '', ...proceso.estadoAprobacion },
            verificacion: { ...proceso.estadoVerificacion },
        });

        return proceso;
    };

    private readonly actualizarVerificacion = async (
        id: number,
        tieneFirmas: boolean,
        tieneFotocopias: boolean,
        tieneHuellas: boolean,
    ) => {
        return clienteApi
            .ejecutar('actualizarVerificacion', {
                id,
                tieneFirmas,
                tieneFotocopias,
                tieneHuellas,
            })
            .then(() => this.obtenerMatricula())
            .then(resp => ({ ...resp.estadoVerificacion }))
            .catch(this.context.mostrarModalError);
    };

    private readonly aprobarMatricula = async (id: number) => {
        return clienteApi
            .ejecutar('aprobarProcesoDeMatricula', id)
            .then(() => this.obtenerMatricula())
            .then(resp => ({ motivo: '', ...resp.estadoAprobacion }))
            .catch(this.context.mostrarModalError);
    };

    private readonly rechazarMatricula = async (id: number, motivo: string) => {
        return clienteApi
            .ejecutar('rechazarProcesoDeMatricula', {
                idProceso: id,
                motivo,
            })
            .then(() => this.obtenerMatricula())
            .then(resp => ({ motivo: '', ...resp.estadoAprobacion }))
            .catch(this.context.mostrarModalError);
    };
}

export default ProcesoDeMatricula;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/Supervision/ProcesoDeMatricula/index.tsx